import { createQueryData } from '../helpers/createQueryData';

const endPoint = 'Acceptance/acceptance_view_get_for_individual_dates_flats';

const { useQuery } = createQueryData({
  endPoint,
});

const useRoomsForIndividualDates = ({
  params: { acceptanceId, houseId } = {},
  options,
}) =>
  useQuery({
    params: { acceptanceId, houseId },
    options: {
      enabled: Boolean(acceptanceId),
      staleTime: 0,
      ...options,
    },
  });

export { useRoomsForIndividualDates };
